module.exports = __webpack_public_path__ + "static/media/bg-frame-desk.9f1da5db.svg";